import ProfileProviders from './profile-providers';

export default ProfileProviders;
